module.exports = __webpack_public_path__ + "img/1_polygon_art.eecab6e7.png";